import { createFileRoute } from '@tanstack/react-router';
import { SEO } from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import ProfileComponent from './components/Profile';
import messages from './messages';

export const Route = createFileRoute('/_authenticated/settings/')({
  component: Profile,
});

function Profile() {
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const portfolioMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={portfolioMessages.title}
        description={portfolioMessages.description}
        keywords={portfolioMessages.keywords}
        page="profile"
      />
      <div className="px-6 py-4 pt-2">
        <ProfileComponent />
      </div>
    </>
  );
}

export default Profile;
